<template>
  <main-structure class="ng-library" dir="ver">
    <template slot="header">
      <span class="title">开通记录</span>

      <div class="header-content header-search-content">
        <a-input-search
          class="ng-input-search"
          placeholder="请输入用户ID"
          :default-value="$route.query.keyword || ''"
          @search="onSearch"
          allowClear
        >
          <a-button slot="enterButton" type="sub">
            <a-icon type="search" />
          </a-button>
        </a-input-search>
      </div>
    </template>

    <template>
      <!-- <filter-order @change="onFilterChange" :defaultData="$route.query" class="m-top-base"></filter-order> -->

      <div class="m-top-base flex-1" ref="ngTableBox">
        <manage-table
          v-if="$root.$checkAuth($auth[name] && $auth[name].list)"
          :scrolly-height="mainContentScrollMaxHeight"
          :auth-name="name"
          :table-params="tableParams"
          :order_id="$route.params.order_id"
          ref="ngTable"
        ></manage-table>
      </div>
    </template>
  </main-structure>
</template>

<script>
  import ManageTable from './components/ManageTable.vue';
  // import FilterOrder from './components/FilterOrder.vue'

  import {mainContentMixin, filterReq} from '@/mixins';

  export default {
    data() {
      return {
        name: `package_buyRecord`,

        isReloadTable: false,

        tableParams: {}
      }
    },

    mounted() {
      let {time = [], page = 1, keyword} = this.$route.query;

      let params = {time, page, user_id: keyword};

      // params = this.parseArrParams({...params});

      this.tableParams = params;
    },

    components: {
      ManageTable,
      // FilterOrder
    },

    mixins: [
      mainContentMixin,
      filterReq
    ],

    methods: {
      // onFilterChange(values) {
      //   let params = Object.assign({}, this.tableParams, values);

      //   params = this.parseArrParams(params);

      //   this.tableParams = this.filterCommon(params);
      // },

      onSearch(keyword) {
        typeof keyword === 'string' && (keyword = keyword.trim());

        let search = {keyword, page: 1};

        this.$root.$goSearch(search);

        this.tableParams = Object.assign({}, search, {user_id: keyword});
      },
    }
  }
</script>

<style lang="scss" scoped>
</style>
